const infoData = [
    {
        img: "/Images/search1.png",
        imgHov: "/Images/searchhov.png",
        title: "Identify credible NPO partners",
        content: "Efficiently find organizations that will meet your goals and gain more valuable partnerships with GuideStar India’s Solutions.",
        btnName: "Learn more",

    },
    {
        img: "/Images/presentation1.png",
        imgHov: "/Images/presentationhov.png",
        title: "Support Capacity Building and Due Diligence for NPOs",
        content: "Educate and equip NPOs to build trust and transparency through a comprehensive framework.",
        btnName: "Learn more",

    },
    {
        img: "/Images/signal1.png",
        imgHov: "/Images/signalhov.png",
        title: "Access API solutions for your programmes",
        content: "Power your platforms with GuideStar India’s APIs to support your organizational needs.",
        btnName: "Contact us",
        update: "Coming soon"

    },
    {
        img: "/Images/file1.png",
        imgHov: "/Images/filehov.png",
        title: "Attract donors with your NPO profile",
        content: "Claim and update your organization’s NPO/ NGO profile. Earn a Seal of Transparency to give donors the information and confidence they need to support you. (Good news: at no cost for Engage Level)",
        btnName: "Update now",

    }
]
export { infoData }